import React, { useState, useContext, useEffect, useCallback } from 'react';
import AuthContext from '../context/AuthContext';
import CreateDog from '../components/CreateDog';
import FindWalker from '../components/FindWalker';
import MyDogs from '../components/MyDogs';
import EverydayShop from '../components/EverydayShop';
import RememberingMyDog from '../components/RememberingMyDog';
import ActiveWalk from '../components/ActiveWalk';
import ReviewAndRebook from '../components/ReviewAndRebook';

const OwnerDashboard = () => {
  const { getToken } = useContext(AuthContext);
  const [view, setView] = useState('home');
  const [dogs, setDogs] = useState([]);

  const fetchDogs = useCallback(async () => {
    try {
      const response = await fetch('/api/dogs', {
        headers: { 'Authorization': `Bearer ${getToken()}` }
      });
      const data = await response.json();
      setDogs(data);
    } catch (err) {
      console.error('Error fetching dogs:', err);
    }
  }, [getToken]);

  useEffect(() => {
    fetchDogs();
  }, [fetchDogs]);

  return (
    <div className="dashboard">
      <nav className="dashboard-nav">
        <button className={view === 'home' ? 'active' : ''} onClick={() => setView('home')}>
          Home
        </button>
        <button className={view === 'dogs' ? 'active' : ''} onClick={() => setView('dogs')}>
          My Dogs
        </button>
        <button className={view === 'create-dog' ? 'active' : ''} onClick={() => setView('create-dog')}>
          Add Dog
        </button>
        <button className={view === 'find-walker' ? 'active' : ''} onClick={() => setView('find-walker')}>
          Find Walker
        </button>
        <button className={view === 'shop' ? 'active' : ''} onClick={() => setView('shop')}>
          Shop
        </button>
      </nav>
      <nav className="dashboard-nav dashboard-nav-secondary">
        <button className={view === 'remembering' ? 'active' : ''} onClick={() => setView('remembering')}>
          Remembering My Dog
        </button>
      </nav>

      <div className="dashboard-content">
        {view === 'home' && (
          <div className="home-panel">
            <h2>Welcome, Dog Owner</h2>
            <p>You have {dogs.length} dog(s).</p>
            <p>Ready to find a walker? Use the "Find Walker" tab.</p>
            <ActiveWalk />
            <ReviewAndRebook />
          </div>
        )}
        {view === 'dogs' && <MyDogs dogs={dogs} onRefresh={fetchDogs} />}
        {view === 'create-dog' && <CreateDog onSuccess={fetchDogs} />}
        {view === 'find-walker' && <FindWalker />}
        {view === 'shop' && <EverydayShop />}
        {view === 'remembering' && <RememberingMyDog />}
      </div>
    </div>
  );
};

export default OwnerDashboard;
